import { Box } from '@mui/material';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon, Row, Text } from '@/components/ui';
import { getFormattedDate } from '@/lib/dateFormatting';
import type { Project } from '../types';
import siteSmallIcon from '@/assets/site-small.svg';

interface Props {
  project: Project;
  handleClick: () => void;
}

export const ProjectCard: FC<Props> = ({ project, handleClick }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        mt: '0.5rem', // 8px
        padding: '0.5rem', // 8px
        border: '1px solid',
        borderColor: '#707070',
        boxShadow: '0rem 0.0625rem 0.1875rem 0rem #0000001A', // 0px 1px 3px 0px
        background: 'white',
        borderRadius: '0.5rem', // 8px
        cursor: 'pointer',
      }}
      onClick={handleClick}
    >
      <Box>
        <Text sx={{ color: 'black', fontWeight: 'bold' }}>
          {project.projectName}
        </Text>
      </Box>
      <Box>
        <Row sx={{ justifyContent: 'space-between' }}>
          <Row spacing={'0.25rem'}>
            <Icon sx={{ mb: '0.125rem' }} src={siteSmallIcon} />
            <Text sx={{ color: 'black' }}>{project.siteCount}</Text>
            <Text sx={{ color: 'black' }}>{t('site_count_projects_page')}</Text>
          </Row>
          <Row spacing={'0.25rem'}>
            <Text sx={{ color: 'black' }}>
              {t('created_date_projects_page')}
            </Text>
            <Text sx={{ color: 'black' }}>
              {getFormattedDate(project.creationDate)}
            </Text>
          </Row>
        </Row>
        <Box height='2.25rem' sx={{ display: 'block' }}></Box> {/* 36px */}
      </Box>
    </Box>
  );
};
